import { render, staticRenderFns } from "./AutoAssignTag.vue?vue&type=template&id=005fb60a"
import script from "./AutoAssignTag.vue?vue&type=script&lang=js"
export * from "./AutoAssignTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports